import moment from 'moment'
import { fetchDataInitTable } from '../shared-script/fetchDataInitTable'
import defaultSortParams from '../shared-script/defaultSortParams'
const { moco } = require('../../MbaasClient')

export async function isPoinLedgers(params, resource) {
  console.log(6234958776, { method: 'getList', resource: resource, params: params })
  const { user_id, customer_id, type, credit_category, credit_type, dateGte, dateLte } =
    params.filter || {}
  const { page, perPage } = params.pagination
  let { field: sortField, order: sortOrder } = params.sort

  // adjust sorting params, default sort DESC
  const [field, order] = defaultSortParams(sortField, sortOrder)

  let filterObject = moco.composeFilter()
  let includedTables = ['users', 'customers', 'transactions']

  if (user_id) filterObject = filterObject.eq('user_id', user_id)
  if (customer_id) filterObject = filterObject.eq('customer_id', customer_id)
  if (type) filterObject = filterObject.eq('type', type)
  if (credit_category) filterObject = filterObject.eq('category', credit_category)
  if (credit_type) filterObject = filterObject.eq('credit_type', credit_type)

  if (dateGte && dateLte) {
    filterObject = filterObject.and((x) =>
      x
        .ge('created_at', moment(dateGte).startOf('day').toISOString())
        .le('created_at', moment(dateLte).endOf('day').toISOString())
    )
  }

  if (filterObject !== '') filterObject = filterObject.toString()

  const [data, total] = await fetchDataInitTable(
    includedTables,
    resource,
    filterObject,
    order,
    field,
    page,
    perPage
  )

  const mappedData = data.map((value) => {
    return {
      ...value,
      credit: value?.credit?.toFixed(2),
      debit: value?.debit?.toFixed(2),
      ending_balance: value?.ending_balance?.toFixed(2),
    }
  })

  return { data: mappedData, total: total }
}
